import Vue from 'vue';
import DropdownApi from '@/api/DropdownApi';

const dropdownApi = new DropdownApi();

const dropdownModule = {
  state: {
    fetching: {},
  },
  getters: {
    getDropdownOptions: (state) => (dropdownId, languageId) => {
      if (state[dropdownId] && state[dropdownId][languageId]) {
        return state[dropdownId][languageId];
      }
      return [];
    },
  },

  mutations: {
    SET_DROPDOWNOPTIONS: (state, dropdown) => {
      const optionsObject = {};
      optionsObject[dropdown.languageId] = dropdown.options;
      Vue.set(state, dropdown.id, optionsObject);
    },
    SET_FETCHING_DROPDOWN: (state, fetchingStatus) => {
      Vue.set(state.fetching, fetchingStatus.id, fetchingStatus.fetching);
    },
  },
  actions: {
    loadDropdown: (context, {
      id,
      languageId,
      refresh,
      params,
    }) => {
      if (!refresh && context.state.fetching[id]) {
        return context.state.fetching[id];
      }

      const dropdownPromise = dropdownApi.getOptionValues(id, languageId, params).then((options) => {
        context.commit('SET_DROPDOWNOPTIONS', { id, languageId, options });
        return context.state[id][languageId];
      }, () => {
        context.commit('SET_DROPDOWNOPTIONS', { id, languageId, options: [] });
      });
      context.commit('SET_FETCHING_DROPDOWN', { id, fetching: dropdownPromise });
      return dropdownPromise;
    },
  },
};

export default dropdownModule;
